import React from 'react';

const CircleLoader = ({ isComplete }) => {
  return (
    <div className={`circle-loader ${isComplete ? 'load-complete' : ''}`}>
      <div className={`checkmark ${isComplete ? 'draw' : ''}`} />
    </div>
  );
};

export default CircleLoader;